import React, { useContext, useEffect, useState } from 'react'
import { RootContext as context } from '~/state'
import { GraphEdge } from './GraphEdge'

export const GraphEdges = (): JSX.Element => {
  const { graph, layout } = useContext(context)

  const [edges, setEdges] = useState<JSX.Element[]>([])

  const rootExists = layout?.root ?? undefined !== undefined
  const refreshEdges = graph?.edges?.length ?? 0 !== edges.length

  useEffect(() => {
    if (!rootExists || !refreshEdges) {
      return
    }

    const e = graph?.edges?.map((edge, i) => <GraphEdge key={`edge-${i}-${edge.from}-${edge.to}`} edge={edge} />) ?? []
    setEdges(e)
  }, [graph, rootExists, refreshEdges])

  return <>{edges}</>
}
